// @ts-nocheck
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import XCircle from "@insite/mobius/Icons/XCircle";
import { LinkProps } from "@insite/mobius/Link";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BlockProps } from "@store/Library/Components/Toolkit/Block";
import { FlexWrapperPresentationProps, FlexWrapperProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import AlertCircle from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleLine";
import Undo from "@store/Library/Components/Icons/Undo";
import { formFieldQtyFieldStyles } from "@store/Themes/common/mixins/formField";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface OrderChangeStyles {
    orderLineCardGridContainer?: GridContainerProps;
    orderLineCartWrapper?: InjectableCss;
    block?: BlockProps;
    ftlWrapper?: InjectableCss;
    leadTimeWrapper?: InjectableCss;
    shipFromLabel?: TypographyPresentationProps;
    shipFromText?: TypographyPresentationProps;
    leadTimeText?: TypographyPresentationProps;
    leadTimeTooltip?: TooltipPresentationProps;
    canceledTag?: InjectableCss;
    canceledLineOverlayItem?: GridItemProps;
    addedTag?: InjectableCss;
    addedLineOverlayItem?: GridItemProps;
    reasonGridItem?: GridItemProps;
    notesGridItem?: GridItemProps;
    qtyGridItem?: GridItemProps;
    ocrGridContainer?: GridContainerProps;
    changeInfoHeadingAndText?: SmallHeadingAndTextStyles;
    undoRemoveLink?: LinkProps;
    removeLink?: LinkProps;
    changeRequestGridContainer?: GridContainerProps;
    shipmentDetailsWrapper?: InjectableCss;
    changeRequestFlexWrapper?: FlexWrapperProps;
    editableNotesTextArea?: TextFieldPresentationProps;
    qtyTextField?: TextFieldPresentationProps;
    lineActionWrapper?: InjectableCss;
    lineActionFlexWrapper?: FlexWrapperPresentationProps;
    actionFiller?: InjectableCss;
}

export const orderChangeProps: OrderChangeStyles = {
    block: {
        margin: "narrow",
        variantProps: {
            separated: {
                adaptToContext: true,
            },
        },
        containerCss: css`
            ${spacingStyles(null, pxToRem(32))}
        `,
    },
    orderLineCardGridContainer: {
        css: css`
            word-break: break-word;
            position: relative;
            ${x => gridGapStyles(pxToRemArray([20]), [x.theme.design.typography.spacing.base])}
            ${breakpointValues([pxToRem(24, 0), pxToRem(32, 0), null, null, null], "padding")}
        `,
    },
    orderLineCartWrapper: {
        css: css`
            border-width: 1px;
            border-style: solid;
            ${spacingStyles(null, pxToRem(32))}
        `,
    },
    ftlWrapper: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin-bottom: ${pxToRem(8)};
        `,
    },
    shipFromLabel: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    leadTimeText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    leadTimeTooltip: {
        iconProps: {
            src: AlertCircle,
        },
    },
    canceledLineOverlayItem: {
        width: 12,
        css: css`
            position: absolute;
            content: "";
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(255, 255, 255, 0.6);
            z-index: 999;

            &&&& {
                padding: 0;
            }
        `,
    },
    canceledTag: {
        css: css`
            color: ${getColor("danger.contrast")};
            background-color: ${getColor("danger")};
            padding: ${pxToRem(8)};
        `,
    },
    addedLineOverlayItem: {
        width: 12,
        css: css`
            position: absolute;
            content: "";
            top: 0;
            left: 0;
            z-index: 999;

            &&&& {
                padding: 0;
            }
        `,
    },
    addedTag: {
        css: css`
            color: ${getColor("success.contrast")};
            background-color: ${getColor("success")};
            padding: ${pxToRem(8)};
        `,
    },
    ocrGridContainer: {
        css: css`
            background-color: ${getColor("common.accent")};
            ${breakpointValues([pxToRem(24), pxToRem(32), null, null, null], "padding")}
        `,
    },
    reasonGridItem: {
        width: [12, 12, 4, 3, 3],
    },
    notesGridItem: {
        width: [12, 12, 5, 6, 7],
    },
    qtyGridItem: {
        width: [12, 12, 3, 3, 2],
    },
    changeInfoHeadingAndText: {
        heading: {
            css: css`
                ${({ theme }) => css`
                    font-weight: ${theme.design.typography.weight.bold};
                    font-size: ${theme.design.typography.size.smaller};
                `}
            `,
        },
    },
    undoRemoveLink: {
        icon: {
            iconProps: {
                color: "link",
                src: Undo,
                css: css`
                    margin-right: ${pxToRem(5)};
                `,
            },
        },
    },
    removeLink: {
        icon: {
            iconProps: {
                color: "link",
                src: XCircle,
                css: css`
                    margin-right: ${pxToRem(5)};
                `,
            },
        },
    },
    changeRequestGridContainer: {
        css: css`
            background-color: ${getColor("common.accent")};
            ${breakpointValues([pxToRem(24), pxToRem(32), null, null, null], "padding")}
        `,
    },
    shipmentDetailsWrapper: {
        css: css`
            width: 100%;
            padding-left: ${pxToRem(10)};
        `,
    },
    changeRequestFlexWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    width: 100%;
                `,
            },
            content: {
                css: css`
                    width: 100%;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    ${breakpointValues([pxToRem(24), pxToRem(32), null, null, null], "gap")}
                `,
            },
            item: {
                css: css`
                    &:first-child {
                        ${breakpointValues(["100%", null, pxToRem(350), null, null], "width")}
                    }

                    &:nth-child(2) {
                        ${breakpointValues(["unset", null, "1", null, null], "flex")}
                        ${breakpointValues(["100%", null, "auto", null, null], "width")}
                    }

                    &:last-child {
                        ${breakpointValues([pxToRem(150), pxToRem(150), pxToRem(150), null, null], "width")}
                    }
                `,
            },
        },
    },
    editableNotesTextArea: {
        cssOverrides: {
            formField: css`
                ${x => x.theme.formField.defaultProps?.cssOverrides?.formField}
                ${spacingStyles(pxToRem(5), null)}
            `,
        },
    },
    qtyTextField: {
        cssOverrides: {
            formInputWrapper: css`
                width: ${pxToRem(112)};
            `,
        },
    },
    lineActionWrapper: {
        css: css`
            flex: 1;
            margin-top: 9px;
            display: flex;
            align-items: center;
        `,
    },
    lineActionFlexWrapper: {
        extendedStyles: {
            content: {
                css: css`
                    height: 100%;
                    flex-direction: column;
                `,
            },
            item: {
                css: css`
                    &:nth-child(2) {
                        flex: 1;
                    }
                `,
            },
        },
    },
    actionFiller: {
        css: css`
            height: ${pxToRem(22)};
            max-height: ${pxToRem(22)};
        `,
    },
};
